export default __webpack_public_path__ + "static/media/link.324e7b62.svg";